import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";

import { documentsV2Api } from "api/documentsV2Api";
import { QUERIES_KEYS } from "queries";

/** The "Dokumenty 2.0" templates whose name contains `search` (all of them when blank). */
export const useDocumentTemplatesV2 = (search: string = "") => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.DOCUMENT_TEMPLATES_V2(search),
    queryFn: () => documentsV2Api.list(search),
    placeholderData: keepPreviousData,
  });

  // Every search of the list, not just the current one: a created, renamed or deleted template changes them all.
  const invalidate = () => queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.DOCUMENT_TEMPLATES_V2_ROOT() });

  return { isLoading, isFetching, templates: data ?? [], invalidate };
};
